import Button from '@/components/Buttons/Button';
import IconButton from '@/components/Buttons/IconButton';
import theme from '@/theme';
import styled from '@emotion/styled';
import { Dialog } from '@mui/material';

export const DeleteDialog = styled(Dialog)`
    .MuiDialog-paper {
        border-radius: 12px;
        display: flex;
        flex-direction: column;
        width: 452px;
        padding: 24px 30px;
        font-family: 'Manrope', sans-serif;
        color: ${theme.colors.black[800]};
        gap: 16px;
    }
`;

export const DeleteText = styled.div`
    color: ${theme.colors.secondary[900]};
    font-family: Manrope;
    font-size: 16px;
    font-weight: 400;
    letter-spacing: 0.15px;
`;

export const StyledButton = styled(Button)`
    font-family: Manrope;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px; /* 150% */
    text-transform: none;

    border-radius: 8px;
    width: 100%;
    height: 44px;
`;

export const TitleWithImg = styled.div`
    display: flex;
    align-items: center;
`;

export const Buttons = styled.div`
    display: flex;
    gap: 8px;
`;

export const Text = styled.h2`
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    letter-spacing: -0.48px;
    margin: 0 0 0 10px;
`;

export const DeleteCloseButton = styled(IconButton)`
    color: ${theme.colors.black[800]};
    padding: 10px;
    position: absolute;
    right: 6px;
    top: 6px;

    svg {
        width: 18px;
        height: 18px;
    }
`;
